export const CHECKOUT_URL =
  'https://kit-constelaciones-familiares-portal.impultienda.ar/checkout'

export function goToCheckout() {
  const checkoutUrl = new URL(CHECKOUT_URL)
  const attributionParams = new URLSearchParams(window.location.search)

  attributionParams.forEach((value, key) => {
    checkoutUrl.searchParams.set(key, value)
  })

  window.location.assign(checkoutUrl.toString())
}
